import React from "react";
import Chart from "react-apexcharts";
import { Form } from "react-bootstrap";

const QueryCategoryDistribution = ({ queryAnalytics = {} }) => {
  const categories = [
    "Missing data",
    "Eligibility issue",
    "SDV discrepancy",
    "Duplicate entry",
    "Out-of-range value",
    "Inconsistent data",
    "Protocol deviation related",
    "Date inconsistency",
    "AE/CM relationship issue",
    "Medical coding issue",
    "Lab abnormality clarification",
    "Visit window deviation",
  ];

  const series = [
    queryAnalytics?.missingData || 12,
    queryAnalytics?.eligibilityIssue || 10,
    queryAnalytics?.sdvDiscrepancy || 14,
    queryAnalytics?.duplicateEntry || 11,
    queryAnalytics?.outOfRangeValue || 10,
    queryAnalytics?.inconsistentData || 9,
    queryAnalytics?.protocolDeviation || 8,
    queryAnalytics?.dateInconsistency || 10,
    queryAnalytics?.aeCmRelationship || 9,
    queryAnalytics?.medicalCodingIssue || 8,
    queryAnalytics?.labAbnormality || 7,
    queryAnalytics?.visitWindowDeviation || 6,
  ];

  const options = {
    chart: {
      type: "donut",
      toolbar: {
        show: false,
      },
    },

    labels: categories,

    colors: [
      "#2563eb", // Missing data
      "#7c3aed", // Eligibility issue
      "#16a34a", // SDV discrepancy
      "#f59e0b", // Duplicate entry
      "#dc2626", // Out-of-range value
      "#0ea5e9", // Inconsistent data
      "#ea580c", // Protocol deviation
      "#6366f1", // Date inconsistency
      "#14b8a6", // AE/CM relationship
      "#a855f7", // Medical coding
      "#f43f5e", // Lab abnormality
      "#84cc16", // Visit window deviation
    ],

    legend: {
      show: true,
      position: "bottom",
      itemMargin: {
        vertical: 4,
      },
      markers: {
        width: 10,
        height: 10,
        radius: 2,
      },
    },

    dataLabels: {
      enabled: false,
    },

    tooltip: {
      y: {
        formatter: (value) => `${value} Queries`,
      },
    },
  };

  const total = series.reduce((a, b) => a + b, 0);

  return (
    <>
      <div className="p-3">
        <Chart
          options={options}
          series={series}
          type="pie"
          height={280}
        />
      </div>
    </>
  );
};

export default QueryCategoryDistribution;